import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'
import ShowMoreText from "react-show-more-text";

const Styles = styled.div `

    // - - TASK TRAIL HEADER - - //

.taskTrailHeader p {
    margin-top: 2%;
    color: #64A61F;
    font-family: DM Sans;
    font-weight: bold;
    margin-bottom: 0px !important;
}

.taskTrailHeader h4 {
    font-family: DM Sans;
    font-weight: bold;
    color: #724E39;
    font-size: 18px;
    margin-top: 1.5%;
}


.taskTrailHeader button {
    margin-top: 1% !important;
    padding: 1% !important;
    background-color: #F5DE89 !important;
    border: 2px solid #F5DE89 !important;
}

    // - - TRAIL NAME - - //

.trailName input {
    width: 35%;
    height: 55px;
    margin-top: 3%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border: 2px solid transparent;
    border-radius: 8px;
    padding: 7px;
    outline: none;
    font-size: 18.5px;
    text-align: center;
    font-family: DM Sans;
}

.trailName p {
    margin-top: 1.5%;
    color: red;
    font-family: DM Sans;
}

.trailBtn button {
    width: 10%;
    margin-top: 1% !important;
    padding: 1% !important;
    background-color: #F5DE89 !important;
    border: 2px solid #F5DE89 !important;
}

    // - - BUILDING TRAIL - - //

.buildingTrail {
    margin-top: 2.5%;
    text-align: center;
}

.buildingTrail h2 {
    text-align: center;
    font-family: Libre Franklin Black;
    font-size: 37.5px;
    font-wieght: bold;
    color: #724E39;
}

.buildingTrail h5 {
    font-family: DM Sans;
    color: #724E39;
    margin-bottom: 2%;
}

    // - - TASK CONTAINER - - //

.taskContainer:after {
    content: "";
    display:table;
    clear: both;
}

.taskContainer2:after {
    content: "";
    display:table;
    clear: both;
}

.taskContainer {
    margin-left: 10%;
    margin-right: 10%;
    background-color: #F5DE89;
    border: 2px solid #F5DE89;
    margin-bottom: 2%;
    padding: 2.5%;
    border-radius: 10px;
}

.taskContainer2 {
    margin-left: 10%;
    margin-right: 10%;
    background-color: #F5DE89;
    border: 2px solid #F5DE89;
    padding: 2.5%;
    border-radius: 10px;
}

.taskCheck {
    width: 15%;
    text-align: center;
    float: left;
}

.taskInfo {
    width: 65%;
    text-align: center;
    float: left;
}

.taskButtons {
    width: 20%;
    text-align: center;
    float: left;
}

.taskTitle {
    width: 20%;
    text-align: center;
    float: left;
}

.taskName {
    width: 60%;
    text-align: center;
    float: left;
}

.taskButtons2 {
    width: 20%;
    text-align: center;
    float: left;
}

    // - - TASK CHECK - - //

.taskCheck input {
    width: 20%;
    outline: none;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    font-family: DM Sans;
    font-size: 20px;
}

    // - - TASK INFO - - //

.taskInfo h4 {
    text-align: left;
    font-family: DM Sans;
    color: #724E39;
}

    // - - TASK BUTTONS - - //

.taskButtons button {
    width: 90%;
    margin-bottom: 1% !important;
    padding-top: 5% !important;
    padding-bottom: 5% !important;
}

    // - - REDO BUTTON - - //

.redoBtn button {
    padding: 1% !important;
    padding-left: 2% !important;
    padding-right: 2% !important;
    margin-top: 0px !important;
    margin-bottom: 1.5% !important;
    margin-left: 0px !important;
}

    // - - FINISH BUTTON - - //

.finishBtn button {
    padding: 1% !important;
    padding-left: 4% !important;
    padding-right: 4% !important;
    margin-top: 0px !important;
    margin-bottom: 1.5% !important;
    margin-left: 0px !important;
}

    // - - DISPLAYING TRAIL - - //

.displayingTrail {
    text-align: center;
}

.displayingTrail h2 {
    text-align: center;
    font-family: Libre Franklin Black;
    font-size: 37.5px;
    font-wieght: bold;
    color: #724E39;
    margin-top: 2.5%;
    margin-bottom: 2%;
}

    // - - TASK NAME SPANS- - //

.taskName {
    margin-top: 0px !important;
    background-color: white;
    border-radius: 9px;
    padding-top: 0.25%;
    padding-left: 0.25%;
    padding-right: 0.25%;
    padding-bottom: 0px;
    height: 100%;
    margin-bottom: 0px;
}

.taskName h5 {
    font-family: DM Sans;
    text-align: left;
    margin-left: 3.5%;
    line-height: 35px;
}

    // - - TASK PIPE - - //

.taskPipe {
    width: 1%;
    background-color: #724E39;
    height: 50px;
    // display-inline: block;
    margin-left: 20%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

    // - - DELETE BUTTON - - //

.deleteBtn button {
    padding: 1% !important;
    padding-left: 2% !important;
    padding-right: 2% !important;
    margin-top: 1.5% !important;
    margin-bottom: 1.5% !important;
    margin-left: 0px !important;
    background-color: #724E39 !important;
    color: #F5DE89 !important; 
    border: 2px solid #724E39 !important;
}

    // - - TASK BUTTONS 2 - - //

.taskButtons2 button {
    width: 95%;
    background-color: white !important;
    color: black !important;
    margin-bottom: 1% !important;
    padding-top: 3% !important;
    padding-bottom: 3% !important;
    margin-top: 0px !important;
}

    // - - DELETE CONFIRMATION MESSAGE - - //

.deleteErrMsg p {
    font-family: DM Sans;
    color: #724E39;
    font-weight: bold;
}

    // - - COMPLETE BANNER - - //

.completeBanner {
    margin-top: 2%;
}

    // - - TRAIL DISPLAY - - //

.trailDisplay {
    text-align: center;
    background-color: #F5DE89;
    margin-left: 15%;
    margin-right: 15%;
    margin-top: 3%;
    padding: 2%;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    cursor: pointer;
}

.trailDisplay h1 {
    font-family: Libre Franklin Black;
    color: #724E39;
    padding-left: 2%;
    padding-right: 2%;
}

    // - - NO TRAIL DISPLAY - - //

.noTrailDisplay {
    margin-top: 4.5%;
}

.noTrailDisplay h2 {
    font-family: DM Sans;
    color: #724E39;
}

// - - - - - - - - - - - PHONE DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 650px) {


        // - - TASK TRAIL HEADER - - //

    .taskTrailHeader p {
        font-size: 13.5px;
        margin-left: 10%;
        margin-right: 10%;
        text-align: justify;
        margin-bottom: 3.5% !important;
    }
        
    .taskTrailHeader h4 {
        margin-left: 10%;
        margin-right: 10%;
        text-align: justify;
        margin-bottom: 5%;
    }

    .taskTrailHeader button {
        padding: 3% !important;
        font-size: 15px !important;
    }

        // - - TRAIL NAME INFO - - //

    .trailName input {
        width: 85%;
        height: 55px;
        margin-top: 3%;
        border-radius: 0px;
        padding: 7px;
        outline: none;
        font-size: 15.5px;
        border-top: 2px solid transparent;
        border-left: 2px solid transparent;
        border-right: 2px solid transparent;
        border-bottom: 1px solid #724E39;
        box-shadow: 0px;
    }

    .trailBtn {
        margin-top: 3% !important;
    }
    
    .trailBtn button {
        padding: 3% !important;
        width: 35% !important;
        margin-bottom: 1.5% !important;
        font-size: 15px !important;
    }

        // - - BUILDING TRAIL - - //

    .buildingTrail h2 {
        margin-left: 3%;
        margin-right: 3%;
        font-size: 22px;
    }

    .buildingTrail h5 {
        font-size: 16.5px;
        text-align: justify;
        margin-left: 10%;
        margin-right: 10%;
        margin-bottom: 3.5%;
    }

        // - - TASK CONTAINER - - //

    .taskContainer {
        margin-left: 5%;
        margin-right: 5%;
        width: 90%;
    }

    .taskContainer2 {
        margin-left: 5%;
        margin-right: 5%;
        width: 90%;
    }

    .taskCheck {
        width: 20%;
        text-align: center;
        float: left;
    }
    
    .taskInfo {
        width: 80%;
        text-align: center;
        float: left;
    }

    .taskButtons {
        margin-top: 1.5%;
        width: 100%;
        text-align: center;
        float: left;
    }

    .taskButtons2 {
        margin-top: 1.5%;
        width: 100%;
        text-align: center;
        float: left;
    }

        // - - TASK CHECK - - //

    .taskCheck input {
        width: 58%;
        outline: none;
        cursor: pointer;
    }

        // - - TASK INFO - - //

    .taskInfo h4 {
        text-align: left;
        font-family: DM Sans;
        color: #724E39;
        font-size: 14.5px;
    }

        // - - TASK BUTTONS - - //

    .taskButtons button {
        padding: 2.5% !important;
        width: 70% !important;
        margin-bottom: 1% !important;
        font-size: 15px !important;
    }

        // - - TASK TITLE - - //

    .taskTitle h5 {
        font-size: 1.5px;
    }

        // - - TASK NAME - - //

    .taskName {
        width: 100% !important;
        height: 100% !important;
    }

    .taskName h5 {
        margin-left: 0px !important;
        line-height: 15px !important;
        padding-top: 2.5% !important;
        padding-bottom: 2.5% !important;
        margin-bottom: 0px !important;
        font-size: 15px !important;
        padding-right: 1% !important;
        padding-left: 2% !important;
    }

        // - - TASK PIPE - - //

    .taskPipe {
        width: 2.5%;
    }

        // - - REDO BUTTON - - //

    .redoBtn button {
        padding: 3% !important;
        padding-left: 3% !important;
        padding-right: 3% !important;
    }
    
        // - - FINISH BUTTON - - //
    
    .finishBtn button {
        padding: 3% !important;
        padding-left: 12% !important;
        padding-right: 12% !important;
        font-size: 15px !important;
    }

    // - - DELETE BUTTON - - //

    .deleteBtn button {
        padding: 3% !important;
        width: 40% !important;
        margin-top: 4% !important;
        font-size: 15px !important;
    }

        // - - TASK 2 BUTTONS - - //

    .taskButtons2 button {
        padding: 2.5% !important;
        width: 70% !important;
        margin-bottom: 1% !important;
        font-size: 15px !important;
    }

        // - - DELETE CONFIRMATION MESSAGE - - //

    .deleteErrMsg p {
        text-align: justify;
        font-size: 15px;
        font-weight: normal;
    }

        // - - DISPLAYING TRAIL - - //

    .displayingTrail h2 {
        margin-left: 3%;
        margin-right: 3%;
        font-size: 22px;
    }

        // - - COMPLETE BANNER - - //

    .completeBanner {
        margin-top: 2%;
    }

    .completeBanner h2 {
        margin-left: 5.5%;
        margin-right: 5.5%;
        font-size: 20px;
        text-align: justify;
    }

        // - - TRAIL DISPLAY - - //

    .trailDisplay {
        margin-left: 10%;
        margin-right: 10%;
        margin-top: 3%;
        padding-top: 3%;
    }

    .trailDisplay h1 {
        font-size: 25px;
    }

}

`

export default class TaskTrail extends Component {
    constructor() {
        super()
        this.state = {
            creatingTrail: true,
            createTrailBtn: true,
            redoBtn: false,
            taskTrailComplete: false,
            trailButtons: true,
            confirmDelete: false,
            displayTrailButtons: true,
            deleteTrailButtons: false,
            trailNameErrMsg: "",
            nameTrail: "",
            taskPosition: 1,
            taskExists: null,
            bothArrays: [],
            incompleteTasks: [],
            maxNum: null,
            selectedTrail: [],
            deleteMsg: "",
            taskCompletedMsg: "",
            allTrails: []
        }
    }

    componentDidMount = () => {
        this.state.bothArrays = this.props.highPriorityBucket.concat(this.props.lowPriorityBucket)
        this.state.bothArrays = this.state.bothArrays.filter(task => {
            return task.completed == false
        })
        this.state.bothArrays = this.state.bothArrays.filter((v, i) => {
            if (!Object.keys(v).includes("trailPosition")) {
                Object.defineProperty(v, "trailPosition", {
                    value: 0,
                    writable: true,
                    enumerable: true
                })
            }
            return v
        })
        this.state.bothArrays = this.state.bothArrays.filter((v, i) => {
            if (!Object.keys(v).includes("addBtn")) {
                Object.defineProperty(v, "addBtn", {
                    value: true,
                    writable: true
                })
            }
            return v
        })
        this.setState({
            incompleteTasks: this.state.bothArrays
        })
        this.loadAllTrails()
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

    sortTaskInTrail = (id) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .get().then(querySnapshot => {
            var data = querySnapshot.docs.map(doc => doc.data().position)
            if (data[0] == undefined) {
                console.log("The sortTaskInTrail function works sir 👴🏻")
                return
            } else {
                if (data.includes(undefined)) {
                    data = data.filter((id) => id !== undefined)
                }
                this.state.maxNum = Math.max(...data)
                if (this.state.maxNum >= 3) {
                    this.setState({
                        taskTrailComplete: true
                    })
                } else {
                    this.setState({
                        taskTrailComplete: false
                    })
                }
                if (this.state.maxNum == 1) {
                    var stateCopy = [...this.state.incompleteTasks]
                    let obj = stateCopy.find(f=>f.id==id);
                    if(obj){
                        obj.trailPosition=this.state.maxNum;
                    }
                    this.setState({
                        incompleteTasks: stateCopy
                    })
                    this.state.maxNum = this.state.maxNum+1
                    this.setState({
                        taskPosition: this.state.maxNum,
                    }) 
                } else {
                    if (this.state.maxNum <= this.state.incompleteTasks.length) {
                        var stateCopy = [...this.state.incompleteTasks]
                        let obj = stateCopy.find(f=>f.id==id);
                        if(obj){
                            obj.trailPosition=this.state.maxNum;
                        }
                        this.setState({
                            incompleteTasks: stateCopy
                        })
                        this.state.maxNum = this.state.maxNum+1
                        this.setState({
                            taskPosition: this.state.maxNum,
                        }) 
                    }
                }
            }
        })
    }

    checkTaskExists = (id) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data().id)
            console.log(data)
            if(data.includes(id)) {
                console.log("we're heeeere baby - but error still alive")
                return true
            } else {
                console.log("How'd we get heree")
                return false
            }
        })
    }

    addTaskToTrail = (id, task) => {
        this.setState({
            redoBtn: true
        })
        //* PART ONE - - Get rid of add button
        var stateCopy = [...this.state.incompleteTasks]
        let obj = stateCopy.find(f=>f.id==id);
        if(obj){
            obj.addBtn=false;
        }
        this.setState({
            incompleteTasks: stateCopy,
        })

        //* PART TWO - change UI of order
        this.sortTaskInTrail(id)
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .doc(id)
        .set({
            id: id,
            position: this.state.taskPosition,
            task: task,
            deleting: false,
            completed: false,
            bgColor: "",
            pipeColor: "",
            lastElement: false
        })
    }

    renderAllTasks = () => {
        return this.state.incompleteTasks.map(tasks => {
            var {task, id, trailPosition, addBtn} = tasks

                if (addBtn == true) {
                    this.state.showAddTaskBtn = true
                } else {
                    this.state.showAddTaskBtn = false
                }
            
            return (
                <Styles>
                    <div className='taskContainer'>
                        <div className='taskCheck'>
                            <input
                            value={trailPosition}
                            readOnly
                            />
                        </div>
                        <div 
                        className='taskInfo'
                        >
                            <h4>{task}</h4>
                        </div>
                        {this.state.showAddTaskBtn && 
                            <div className='taskButtons'>
                                <button
                                onClick={() => this.addTaskToTrail(id, task)}
                                >Add To Trail</button>
                            </div>
                        }
                    </div>
                </Styles>
            )
        })
    }

    goToNameTrail = () => {
        this.setState({
            trailName: true,
            createTrailBtn: false,
            nameTrail: ""
        })
    }

    cancelNameTrail = () => {
        this.setState({
            trailName: false,
            createTrailBtn: true,
            trailNameErrMsg: ""
        })
    }

    createTaskTrail = () => {
            // for loadAllTrails
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .add({
           name: this.state.nameTrail 
        })
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .doc("created")
        .set({
           name: this.state.nameTrail 
        })
    }

    goToCreateTrail = () => {
        if(!this.state.nameTrail == "") {
            this.setState({
                creatingTrail: false,
                buildingTrail: true
            })
            this.createTaskTrail()
        } else {
            this.setState({
                trailNameErrMsg: "Please enter a name for your task trail"
            })
        }
    }

    deleteTaskTrail = () => {
        var stateCopy = [...this.state.incompleteTasks]
        stateCopy.forEach((el)=>{el.addBtn = true;}) 
        stateCopy.forEach((el)=>{el.trailPosition = 0;}) 
        this.setState({
            incompleteTasks: stateCopy,
            redoBtn: false,
            taskPosition: 1,
            taskTrailComplete: false
        })
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                doc.ref.delete()
            })
        })
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .where('name', '==', this.state.nameTrail)
        .get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                doc.ref.delete()
            })
        })
        this.setState({
            creatingTrail: true,
            buildingTrail: false
        })
        this.loadAllTrails()
        // this.renderAllTasks()
    }

    redoClicked = () => {
         //* - - Reset UI - - *//
        var stateCopy = [...this.state.incompleteTasks]
        stateCopy.forEach((el)=>{el.addBtn = true;}) 
        stateCopy.forEach((el)=>{el.trailPosition = 0;}) 
        this.setState({
            incompleteTasks: stateCopy,
            redoBtn: false,
            taskPosition: 1,
            taskTrailComplete: false
        })
        //* - - Reset Databse - - *//
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                doc.ref.delete()
            })
        })
    }

    loadTrailFromDb = (inputTrail) => {
        class TaskTrail {
            constructor(bgColor, completed, deleting, 
                id, lastElement, pipeColor, position, task) {
                this.bgColor = bgColor
                this.completed = completed
                this.deleting = deleting
                this.id = id
                this.lastElement = lastElement
                this.pipeColor = pipeColor
                this.position = position
                this.task = task
            }
            toString() {
                return this.bgColor + ', ' + 
                this.completed + ', ' +
                this.deleting + ', ' +
                this.id + ', ' +
                this.lastElement + ', ' +
                this.pipeColor + ', ' +
                this.position + ', ' +
                this.task
            }
        }
        var trailConverter = {
            toFirestore : function(trail) {
                return {
                    bgColor: trail.bgColor,
                    completed: trail.completed,
                    deleting: trail.deleting,
                    id: trail.id,
                    lastElement: trail.lastElement,
                    pipeColor: trail.pipeColor,
                    position: trail.position,
                    task: trail.task
                }
            },
            fromFirestore: function (snapshot, options) {
                const data = snapshot.data(options)
                return new TaskTrail(data.bgColor, data.completed, 
                    data.deleting, data.id, data.lastElement,
                    data.pipeColor, data.position, data.task)
            }
        }
        if (this.state.nameTrail != "") {
            inputTrail = this.state.nameTrail
        }
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(inputTrail)
        .collection("trail")
        .withConverter(trailConverter)
        .get().then(querySnapshot => {
            var data = querySnapshot.docs.map(doc => doc.data())
            data = data.filter(function( obj ) {
                return obj.id !== undefined;
            })
            data = data.sort((a, b) => a.position-b.position)
            var stateCopy = [...data]
            stateCopy[stateCopy.length-1].lastElement = true 
            data = stateCopy
            this.setState({
                selectedTrail: data
            })
        })
        this.checkTrailComplete(inputTrail)
    }

    checkTrailComplete = (inputTrail) => {
        if (this.state.nameTrail != "") {
            inputTrail = this.state.nameTrail
        }
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(inputTrail)
        .collection("trail")
        .get().then(querySnapshot => {
            var data = querySnapshot.docs.map(doc => doc.data().completed)
            data = data.filter(function( obj ) {
                return obj !== undefined;
            })
            console.log(data)
            if(data.includes(false)) {
                this.setState({
                    trailCompleteBanner: false
                })
                return
            } else if (data.length == 0) {
                this.setState({
                    semiCompleteTrail: true
                })
            } else {
                this.setState({
                    trailCompleteBanner: true
                })
            }
        })
    }

    displayTrail = () => {
        this.loadTrailFromDb()
        this.setState({
            buildingTrail:false,
            displayingTrail: true
        })
    }

    goToDeleteTask = (id, deleting) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .doc(id)
        .update({
            deleting: true
        })
        this.loadTrailFromDb()
    }

    cancelDelete = (id) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .doc(id)
        .update({
            deleting: false
        })
        this.loadTrailFromDb()
    }

    removeTaskFromTrail = (id) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .doc(id)
        .delete()
        this.loadTrailFromDb()
    }

    markParentTaskComplete = (id) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("tasks")
        .doc(id)
        .update({
            completed: true
        })
    }

    markParentTaskIncomplete = (id) => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("tasks")
        .doc(id)
        .update({
            completed: false
        })
    }

    taskCompleted = (id, completed) => {
        if (completed == false) {
            fire.firestore().collection("users")
            .doc(this.props.userEmail)
            .collection("taskTrails")
            .doc(this.state.nameTrail)
            .collection("trail")
            .doc(id)
            .update({
                completed: true
            })
            this.markParentTaskComplete(id)
        } else {
            fire.firestore().collection("users")
            .doc(this.props.userEmail)
            .collection("taskTrails")
            .doc(this.state.nameTrail)
            .collection("trail")
            .doc(id)
            .update({
                completed: false
            })
           this.markParentTaskIncomplete(id)
        }
        this.loadTrailFromDb()
    }

    renderSelectedTrail = () => {
        return this.state.selectedTrail.map(tasks => {
            var {bgColor, completed, deleting, 
                id, lastElement, pipeColor, positton, task} = tasks

            if (completed == false) {
                this.state.taskCompletedMsg = "Task Complete"
                bgColor = "#F5DE89"
                pipeColor = "#724E39"
            } else {
                this.state.taskCompletedMsg = "You're Done ✅"
                bgColor = "#99CC63"
                pipeColor = "#2BD100"
            }

            if (lastElement == true) {
                this.state.showPipe = false
            } else{
                this.state.showPipe = true
            }

            let divColor = {
                backgroundColor: bgColor,
                border: `2px solid ${bgColor}`
            }

            let pipeColorStyle = {
                backgroundColor: pipeColor
            }

            if (deleting == true) {
                this.state.confirmDelete = true
                this.state.trailButtons = false
                this.state.deleteMsg = "Are you sure you want to remove this task from the trail?"
            } else {
                this.state.confirmDelete = false
                this.state.trailButtons = true
                this.state.deleteMsg = ""
            }

            return(
                <Styles>
                    <div style={divColor} className='taskContainer2'>
                        <div className='taskTitle'>
                            <h5>task - </h5>
                        </div>
                        <div className='taskName'>
                            <h5>{task}</h5>
                        </div>
                        {this.state.trailButtons &&
                            <div className='taskButtons2'>
                                <button
                                onClick={() => this.taskCompleted(id, completed)}
                                >{this.state.taskCompletedMsg}</button>
                                <button
                                 onClick={() => this.goToDeleteTask(id, deleting)}
                                >Delete ❌</button>
                            </div>
                        }
                        {this.state.confirmDelete && 
                            <div className='taskButtons2'>
                                <button
                                onClick={() => this.removeTaskFromTrail(id)}
                                >Yes ✅</button>
                                <button
                                onClick={() => this.cancelDelete(id, deleting)}
                                >No ❌</button>
                            </div>
                        }
                        <br/>
                        <div className='deleteErrMsg'>
                            <p>{this.state.deleteMsg}</p>
                        </div>
                    </div>
                    {this.state.showPipe &&
                        <div style={pipeColorStyle} className='taskPipe'></div>
                    }
                </Styles>
            )
        })
    }

    confirmTrailDeleting = () => {
        this.setState({
            displayTrailButtons: false,
            deleteTrailButtons: true
        })
    }

    cancelTrailDeleting = () => {
        this.setState({
            displayTrailButtons: true,
            deleteTrailButtons: false,
        })
    }

    deleteCurrentTrail = () => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .doc(this.state.nameTrail)
        .collection("trail")
        .get().then(querySnapshot => {
            querySnapshot.forEach(doc => {
                doc.ref.delete()
            })
        })
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .where('name', '==', this.state.nameTrail)
        .get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                doc.ref.delete()
            })
        })
        this.setState({
            displayingTrail: false,
            creatingTrail: true,
            nameTrail: "",
            displayTrailButtons: true,
            deleteTrailButtons: false,
        })
        this.loadAllTrails()
    }

    loadAllTrails = () => {
        fire.firestore().collection("users")
        .doc(this.props.userEmail)
        .collection("taskTrails")
        .get().then(querySnapshot => {
            const data = querySnapshot.docs.map(doc => doc.data().name)
            console.log(data)
            this.setState({
                allTrails: data
            })
        })
    }

    backToTrails = () => {
        this.setState({
            trailName: false,
            displayingTrail: false,
            creatingTrail: true,
            createTrailBtn: true
        })
        this.loadAllTrails()
    }

    trailClicked = (trail) => {
        this.loadTrailFromDb(trail)
        this.setState({
            creatingTrail: false,
            displayingTrail: true,
            nameTrail: trail,
        })
    }

    renderAllTrails = () => {
        return (
            <Styles>
                <div>{this.state.allTrails.length != 0 ? (
                    this.state.allTrails.map(trail => (
                        <div 
                        className='trailDisplay'
                        onClick={() => this.trailClicked(trail)}
                        >
                            <h1>{trail}</h1>
                        </div>
                    ))) : (
                        <div className='noTrailDisplay'>
                            <h2>No trails created</h2>
                        </div> 
                    ) }
                    
                </div>
            </Styles>
        )
    }

    render () {
        return(
            <Styles>
                {this.state.creatingTrail && 
                    <div>
                        {this.state.createTrailBtn && 
                            <div className='taskTrailHeader'>
                                <button
                                onClick={this.goToNameTrail}
                                >Create a Trail</button>
                                <h4>Build up some momentum by creating a trail of tasks you can do immediately one after another 👍</h4>
                                <p>If trail exists after you deleted it, head 'Back to Tasks' then come back here and it should be gone</p>
                                <div>
                                    {this.renderAllTrails()}
                                </div>
                            </div>
                        }
                        {this.state.trailName &&
                            <div className='trailName'>
                                <input
                                placeholder='Enter your trail name here'
                                id="nameTrail"
                                value={this.state.nameTrail}
                                onChange={this.handleChange}
                                />
                                <p>{this.state.trailNameErrMsg}</p>
                                <div className='trailBtn'>
                                    <button
                                    onClick={this.goToCreateTrail}
                                    >Continue</button>
                                </div>
                                <div className='trailBtn'>
                                    <button
                                    onClick={this.cancelNameTrail}
                                    >Back</button>
                                </div>
                            </div>
                        }
                    </div>
                }
                {this.state.buildingTrail && 
                    <div className='buildingTrail'>
                        <h2>{this.state.nameTrail}</h2>
                        <h5>Select the tasks you want to add to the trail (<b>in order</b>):</h5>
                        {this.state.redoBtn && 
                            <div className='redoBtn'>
                                <button
                                onClick={this.redoClicked}
                                >Redo</button>
                            </div>
                        }
                        {this.renderAllTasks()}
                        {this.state.taskTrailComplete &&
                            <div className='finishBtn'>
                                <button
                                onClick={this.displayTrail}
                                >Finish</button>
                            </div>
                        }
                        <div className='trailBtn'>
                            <button
                            onClick={this.deleteTaskTrail}
                            >Cancel</button>
                        </div>
                    </div>
                }
                {this.state.displayingTrail && 
                    <div className='displayingTrail'>
                        <h2><u>{this.state.nameTrail}</u></h2>
                        {this.state.trailCompleteBanner &&
                            <div className='completeBanner'>
                                <h2>Congratulations!  Your trail is complete 🎉 ✅ 🐛</h2>
                            </div>
                        }
                        {this.renderSelectedTrail()}
                        {this.state.trailCompleteBanner &&
                            <div className='completeBanner'>
                                <h2>Congratulations! Your trail is complete 🎉 ✅ 🐛</h2>
                            </div>
                        }
                        {this.state.semiCompleteTrail &&
                            <div className='completeBanner'>
                                <h2>Looks like you accidentally created a trail with no tasks.
                                    Not to worry! To re-make this trail, delete it by pressing the 'Delete' button below - and create a new one with the same name
                                </h2>
                            </div>
                        }
                        {this.state.displayTrailButtons && 
                            <div>
                                <div className='deleteBtn'>
                                    <button
                                    onClick={this.confirmTrailDeleting}
                                    >Delete</button>
                                </div>
                                <div className='finishBtn'>
                                    <button
                                    onClick={this.backToTrails}
                                    >Back to Tasks</button>
                                </div>
                            </div>
                        }
                        {this.state.deleteTrailButtons && 
                            <div className='trailBtn'>
                                <button
                                onClick={this.deleteCurrentTrail}
                                >Yes ✅</button>
                                <br/>
                                <button
                                onClick={this.cancelTrailDeleting}
                                >No ❌</button>
                            </div>
                        }
                    </div>
                }
            </Styles>
        )
    }
}
